// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import initialState from './initialState'


// Controller
import controller from './controller'

// Exports
export default createReducer({
  ...initialState,
}, {
  ...controller.reducers,
})
